import { DeleteIcon, EditIcon, SearchIcon } from "@chakra-ui/icons";
import {
  Badge,
  Button,
  Flex,
  IconButton,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Text,
  Tr,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { format, parseISO, isValid } from "date-fns";

const formatDate = (str) => {
  if (!str) return "—";
  // já está em DD/MM/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) return str;
  // ISO ou YYYY-MM-DD
  try {
    const d = str.includes("T") ? new Date(str) : parseISO(str);
    return isValid(d) ? format(d, "dd/MM/yyyy") : str;
  } catch { return str; }
};

const SponsorItem = ({ sponsor, onDelete }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_S3_REGION;
  const folder = "sponsors_images";

  const isExpired = (() => {
    if (!sponsor.endDate) return false;
    try {
      const d = new Date(sponsor.endDate);
      return !isNaN(d) && d < new Date();
    } catch { return false; }
  })();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent borderRadius="1rem">
          <ModalHeader fontSize="1rem" fontWeight={700} borderBottom="1px solid" borderColor="gray.100" pb={3}>
            {sponsor.name}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={4}>
            <Flex flexDir="column" gap={2} fontSize="0.85rem">
              {[["Tipo", sponsor.type], ["Término", formatDate(sponsor.endDate)], ["Status", sponsor.isActive]].map(([label, value]) => (
                <Flex key={label} gap={2}>
                  <Text fontWeight={700} minW="90px" color="gray.600">{label}:</Text>
                  <Text>{value}</Text>
                </Flex>
              ))}
              <Flex gap={2}>
                <Text fontWeight={700} minW="90px" color="gray.600">Link Alvo:</Text>
                <a href={sponsor.targetUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#22a45a", wordBreak: "break-all" }}>
                  {sponsor.targetUrl}
                </a>
              </Flex>
              <Flex justifyContent="center" mt={3}>
                <Image
                  src={`https://${bucket}.s3.${region}.amazonaws.com/${folder}/${sponsor?.images?.[0]}`}
                  objectFit="contain"
                  maxH="180px"
                  borderRadius="0.5rem"
                />
              </Flex>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" variant="outline" size="sm" onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Tr opacity={isExpired ? 0.6 : 1}>
        <Td maxW="180px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" title={sponsor.name} fontSize="0.82rem">
          {sponsor.name}
        </Td>
        <Td fontSize="0.82rem">
          <Badge colorScheme={sponsor.type === "Principal" ? "green" : "gray"} fontSize="0.68rem">
            {sponsor.type}
          </Badge>
        </Td>
        <Td fontSize="0.82rem" whiteSpace="nowrap" color={isExpired ? "red.400" : "inherit"}>
          {formatDate(sponsor.endDate)}
        </Td>
        <Td maxW="160px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap" fontSize="0.82rem">
          <a href={sponsor.targetUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#22a45a" }}>
            Link ↗
          </a>
        </Td>
        <Td>
          <Flex gap={2}>
            <Tooltip label="Detalhar patrocinador">
              <IconButton colorScheme="green" variant="ghost" aria-label="Detalhes" size="xs" onClick={onOpen} icon={<SearchIcon />} />
            </Tooltip>
            <Tooltip label="Editar patrocinador">
              <IconButton
                colorScheme="orange"
                variant="ghost"
                aria-label="Editar"
                size="xs"
                isLoading={isLoading}
                onClick={() => { setIsLoading(true); navigate(`/createSponsor/${sponsor.sponsorId}`); }}
                icon={<EditIcon />}
              />
            </Tooltip>
            <Tooltip label="Excluir patrocinador">
              <IconButton
                colorScheme="red"
                variant="ghost"
                aria-label="Excluir"
                size="xs"
                isLoading={isLoading}
                onClick={() => { setIsLoading(true); onDelete(sponsor.sponsorId); }}
                icon={<DeleteIcon />}
              />
            </Tooltip>
          </Flex>
        </Td>
      </Tr>
    </>
  );
};

export default SponsorItem;
